'use strict';

import { ajaxWrapNew, ResponseDispatcher } from './ajaxWrapNew.js';

function autoUpdateOn() { return document.hidden ? false : true; }

const timers = {};
const data = {};
const inFlight = {};
const pending = {};
const globalData = {};

function normalizeDelay(delay) {
    delay = parseInt(delay, 10);
    if (!delay || delay < 1) {
        return 60000;
    }
    return delay;
}

function setGlobal(key, value) {
    globalData[key] = value;
}

function removeGlobal(key) {
    delete globalData[key];
}
function add(key, id, data, responseCb, delay = 60000) {
    delay = normalizeDelay(delay);
    if (!data[delay]) data[delay] = {};
    if (!data[delay][key]) data[delay][key] = {};
    data[delay][key][id] = {
        data: data,
        responseCb: responseCb
    };
    start(delay);
}
function update(key, id, data, delay = 60000) {
    delay = normalizeDelay(delay);
    if (!data[delay] || !data[delay][key] || !data[delay][key][id]) return;
    data[delay][key][id].data = data;
}
function remove(key, id, delay = 60000) {
    delay = normalizeDelay(delay);
    if (!data[delay] || !data[delay][key] || !data[delay][key][id]) return;

    delete data[delay][key][id];
    if ($.isEmptyObject(data[delay][key])) {
        delete data[delay][key];
    }
    if ($.isEmptyObject(data[delay])) {
        delete data[delay];
        stop(delay);
    }
}
function start(delay, runNow = false) {
    delay = normalizeDelay(delay);
    if (timers[delay]) return;

    if (runNow) {
        run(delay);
    }
    timers[delay] = setInterval(() => {
        run(delay);
    }, delay);
}
function restart(delay) {
    delay = normalizeDelay(delay);
    stop(delay);
    start(delay, false);
}
function stop(delay) {
    delay = normalizeDelay(delay);
    if (timers[delay]) {
        clearInterval(timers[delay]);
        delete timers[delay];
    }
    delete inFlight[delay];
    delete pending[delay];
}
function runAll() {
    for (const delay in data) {
        if (data.hasOwnProperty(delay)) {
            run(delay);
        }
    }
}
function run(delay) {
    delay = normalizeDelay(delay);
    if (!autoUpdateOn()) return;
    if (!data[delay] || $.isEmptyObject(data[delay])) return;
    if ($('.bABCMODE').length > 0) {
        return;
    }

    if (inFlight[delay]) {
        pending[delay] = true;
        return;
    }

    inFlight[delay] = true;

    const dataToSend = $.extend({
        ajax: 1,
        action: 'autoSyncer'
    }, globalData);
    var dataJson = {};
    $.each(data[delay], (key, items) => {
        dataJson[key] = {};
        $.each(items, (id, item) => {
            dataJson[key][id] = item.data;
        });
    });
    dataToSend['data'] = JSON.stringify(dataJson);

    ajaxWrapNew({
        method: 'POST',
        data: dataToSend,
        success: async function (data) {
            try {
                const proceed = await ResponseDispatcher.handle(data, dataToSend.action);
                if (proceed === false) return;
                if (data.ok) {
                    processResponse(delay, data.data);
                }
            } catch (e2) {
                console.log(e2);
            }
        },
        complete: function () {
            inFlight[delay] = false;
            if (pending[delay]) {
                pending[delay] = false;
                run(delay);
            }
        },
        dataType: 'json'
    });
}
function processResponse(delay, responseData) {
    if (!responseData) return;
    $.each(responseData, (key, items) => {
        $.each(items, (id, itemData) => {
            if (data[delay] && data[delay][key] && data[delay][key][id]) {
                const item = data[delay][key][id];
                if (item.responseCb) {
                    const resultData = item.responseCb(itemData);
                    if (resultData && typeof resultData === 'object') {
                        $.extend(true, item.data, resultData);
                    }
                }
            }
        });
    });
}

export const autoSyncer = {
    setGlobal,
    add,
    runAll
};

// @ts-ignore
window.autoSyncer = autoSyncer;

